// extracted by mini-css-extract-plugin
export default {"buttonContainer":"TableMarkSelector_buttonContainer__jFOth","active":"TableMarkSelector_active__k9U0x"};